import { getTimeOutDate } from '@helpers/FormalOffers/getTimeOutDate';
import { ConfettiSVG } from '@svgComponents/confettiSVG/ConfettiSVG';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { MoneyNoDecimals } from '../../../../../ui/moneyNoDecimals';
import { FormalOffer } from '../../../../MyOffers.types';
import { useOffersPageVersion } from '../../../offersPage.helpers';

export const ApprovalHeader = ({
    approvalStatusTimeOut,
    maxCashAmount
}: {
    approvalStatusTimeOut: ReturnType<typeof getTimeOutDate>;
    maxCashAmount: FormalOffer['max_amount'];
}) => {
    const offersPageVersion = useOffersPageVersion();
    const isVersion2_1 = offersPageVersion === '2.1';

    return (
        <div
            className={`p-xl min-m:rounded-s ${isVersion2_1 ? 'bg-success-lt min-m:border-2 min-m:border-success-drk' : 'bg-secondary-95'}`}
            data-testid="approval-header"
        >
            <div className="flex items-center gap-l">
                {!isVersion2_1 && (
                    <ConfettiSVG className="hidden shrink-0 min-sm:block" />
                )}
                <p
                    className={`m-0 ${isVersion2_1 ? 'text-3xl' : 'text-2xl'} font-bold`}
                >
                    <FormattedMessage
                        id="_.approval_header.heading"
                        defaultMessage="You're <strong>approved</strong> for {offeredAmount}"
                        values={{
                            offeredAmount: (
                                <MoneyNoDecimals value={maxCashAmount} />
                            ),
                            strong: (chunks) => (
                                <strong className="text-success-drk">
                                    {chunks}
                                </strong>
                            )
                        }}
                    />
                </p>
            </div>

            <p className="mb-0 mt-s text-l font-reg">
                <FormattedMessage
                    id="_.approval_header.subHeading"
                    defaultMessage="These funds will be available until {timeoutDate}. After that you will need to reapply."
                    values={{
                        timeoutDate: (
                            <span className="font-bold">
                                <FormattedDate
                                    value={new Date(approvalStatusTimeOut)}
                                    day="2-digit"
                                    month="long"
                                    year="numeric"
                                />
                            </span>
                        )
                    }}
                />
            </p>
        </div>
    );
};
